module.exports = __webpack_public_path__ + "img/3dview.650a5b50.png";